import React from 'react';
import Cell from '../Body/Cell';
import { getClassNames } from '../../../utils';

type TFooterCellProps = {
  data?: string | { [key: string]: any };
  column?: {
    hidden?: boolean;
    render?: (...args: any[]) => any;
    sortable?: boolean;
    className?: string;
    filterable?: boolean;
    sorter?: (...args: any[]) => any;
  };
  item?: string | number | Record<string, any>;
};

function FooterCell(props: TFooterCellProps) {
    const {
        data = null,
        column: {
            hidden = false, render = undefined, className = undefined, sortable, filterable, sorter = undefined,
        } = {},
        item = null,
    } = props;

    if (hidden) return null;

    const classNameCell = getClassNames(className,
        { 'cell-sortable': sortable || sorter },
        { 'cell-filterable': filterable });

    return (
        <th role="rowheader" className={classNameCell}>
            {render ? render(item, data, 0) : Cell(item)}
        </th>
    );
}

export default FooterCell;
